import { BaseHeading } from "./BaseHeading.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/headings/Heading2.tsx
const Heading2 = ({ children, color = "gray", size = "h2", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(BaseHeading, {
	order: 2,
	size,
	color,
	ta,
	"data-testid": testId,
	children
});

//#endregion
export { Heading2 };